import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard, Building2, Users, CreditCard,
  Key, ScrollText, Settings, LogOut, Menu, X, ChevronRight
} from 'lucide-react';

const nav = [
  { to: '/admin',          label: 'Dashboard',    icon: LayoutDashboard },
  { to: '/admin/tenants',  label: 'Tenants',      icon: Building2 },
  { to: '/admin/users',    label: 'Usuários',     icon: Users },
  { to: '/admin/planos',   label: 'Planos',       icon: CreditCard },
  { to: '/admin/tokens',   label: 'Tokens / API', icon: Key },
  { to: '/admin/logs',     label: 'Audit Logs',   icon: ScrollText },
  { to: '/admin/config',   label: 'Configurações',icon: Settings },
];

export default function AdminLayout({ children }) {
  const { pathname } = useLocation();
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = async () => { await logout(); navigate('/login'); };

  const SidebarContent = () => (
    <div className="flex flex-col h-full">
      <div className="px-6 py-5 border-b border-white/10">
        <span className="text-white font-bold text-lg tracking-tight">TesIQ <span className="text-xs font-normal text-white/50 ml-1">super admin</span></span>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {nav.map(({ to, label, icon: Icon }) => {
          const active = to === '/admin' ? pathname === '/admin' : pathname.startsWith(to);
          return (
            <Link key={to} to={to} onClick={() => setOpen(false)}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${active ? 'bg-white/15 text-white' : 'text-white/60 hover:bg-white/10 hover:text-white'}`}>
              <Icon size={16} />
              {label}
              {active && <ChevronRight size={14} className="ml-auto" />}
            </Link>
          );
        })}
      </nav>
      <div className="px-3 py-4 border-t border-white/10">
        <div className="px-3 py-2 text-xs text-white/40 truncate mb-2">{user?.email}</div>
        <button onClick={handleLogout}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium text-white/60 hover:bg-white/10 hover:text-white transition-colors">
          <LogOut size={16} /> Sair
        </button>
      </div>
    </div>
  );

  return (
    <div className="flex h-screen bg-stone-50">
      {/* Desktop sidebar */}
      <aside className="hidden lg:flex w-60 flex-col bg-[#0f3d2e] shrink-0">
        <SidebarContent />
      </aside>

      {/* Mobile overlay */}
      {open && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <aside className="relative w-60 h-full bg-[#0f3d2e] flex flex-col z-50">
            <SidebarContent />
          </aside>
        </div>
      )}

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Mobile header */}
        <header className="lg:hidden flex items-center gap-3 px-4 py-3 bg-white border-b border-stone-200">
          <button onClick={() => setOpen(true)} className="p-1.5 rounded-md hover:bg-stone-100">
            <Menu size={20} className="text-stone-600" />
          </button>
          <span className="font-semibold text-stone-800 text-sm">TesIQ Admin</span>
        </header>

        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
